import React, { useState, useEffect } from "react";
import "../Components/Header.css";
import { Link } from "react-router-dom"; //Link
import axios from "../api/axios";
import banner1 from "../assets/images/banner1.png";
import banner4 from "../assets/images/banner4.png";
import banner5 from "../assets/images/banner5.jpg";
import banner6 from "../assets/images/banner6.jpg";

function Hero() {
  const [sliders, setSliders] = useState([]);
  const [fullWidth, setFullWidth] = useState(true);
  const [bgColor, setBgColor] = useState("");

  const defaultSliders = [
    { photo: banner1, url: "/products" },
    { photo: banner4, url: "/products" },
    { photo: banner6, url: "/products" },
    { photo: banner5, url: "/products" },
  ];

  useEffect(() => {
    // Fetch sliders
    axios.get("/sliders")
      .then(res => {
        if (res.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
          setSliders(res.data.data);
        }
      })
      .catch(err => {
        console.error("Error fetching sliders:", err);
      });

    // Fetch slider section settings
    axios.post("/business-settings", { keys: "slider_section_full_width,slider_section_bg_color" })
      .then(res => {
        if (res.data && Array.isArray(res.data)) {
          const findVal = (key) => {
            const setting = res.data.find(s => s.type === key);
            return setting?.value;
          };
          const fullWidthVal = findVal("slider_section_full_width");
          const bgColorVal = findVal("slider_section_bg_color");
          
          if (fullWidthVal !== undefined && fullWidthVal !== null) {
            setFullWidth(String(fullWidthVal) === "1");
          }
          if (bgColorVal) {
            setBgColor(bgColorVal);
          }
        }
      })
      .catch(err => {
        console.error("Error fetching slider settings:", err);
      });
  }, []);

  const activeSliders = sliders.length > 0 ? sliders : defaultSliders;

  const getLinkProps = (url) => {
    if (!url || url === "#") return { isExternal: false, path: "/products" };
    const isExternal = url.startsWith("http://") || url.startsWith("https://");
    return { isExternal, path: url };
  };

  return (
    <div className="hero-outer" style={bgColor ? { backgroundColor: bgColor } : {}}>
      <div className={fullWidth ? "" : "container"}>
        <div id="carouselExampleCaptions" className="carousel slide">
          <div className="carousel-inner">
            {activeSliders.map((slider, index) => {
              const { isExternal, path } = getLinkProps(slider.url);
              return (
                <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
                  <img src={slider.photo} alt={`Hero ${index}`} />
                  <div className="carousel-caption">
                    <h1>Simple Textures. Beautiful Spaces.</h1>
                    {isExternal ? (
                      <a href={path} target="_blank" rel="noopener noreferrer">Browse Collection</a>
                    ) : (
                      <Link to={path}>Browse Collection</Link>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Hero;
